import React, { Component } from 'react';
import './androidDev.css'
import Typing from 'react-typing-animation';

class AndroidDev extends Component {
    constructor(props) {
        super(props)
        this.state = {
            scrolling: false
        }
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll = (event) => {
        if (window.innerWidth > 750) {
            if (window.scrollY > 1000 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }
        else if (window.innerWidth <= 750 && window.innerWidth > 600) {
            if (window.scrollY > 900 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }

        else if (window.innerWidth <= 600 && window.innerWidth > 500) {
            if (window.scrollY > 800 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }
        else if (window.innerWidth <= 500 && window.innerWidth >= 320) {
            if (window.scrollY > 600 && this.state.scrolling !== true) {
                this.setState({ scrolling: true });
            }
        }
    }
    render() {
        return (
            <div className='AndroidDevMainDiv'>

                <div className='AndroidDevMainDivChild1'>
                    <div>
                        <img src={require('../../images/iphone.png')} />
                    </div>
                    <div>
                        <p>
                            <span className='AndroidDevHead1'>Mobile Application</span><span className='AndroidDevHead2'> Development</span>
                        </p>
                        {
                            this.state.scrolling ? (
                                <Typing speed={2}>
                                    <p className='AndroidDevPara'>
                                        I recognize myself as a self-motivated and hard-working person, and with a high level of responsibility, I always try my best to complete any project with the highest quality. To further sharpen my skill set, I am continuously acquiring new technologies and seeking more challenging jobs.
            I’ve been practicing both traditional and modern programming languages, namely React Native for mobile application development.
            I have a solid background in creating complex mobile applications for iPhone and Android using React-Native. I can work independently and respect a deadline. I feel comfortable working with a good team of developers.
                            </p>
                                </Typing>

                            ) : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default AndroidDev;



// WEBPACK FOOTER //
// ./src/containers/androiddev/androidDev.js